{
  "04f6d09aa840de5b": "Eliminar documento",
  "0e47f09a748fa132": "Acercar",
  "19766ed6ccb2f4a3": "Cancelar",
  "1eaa68d4c375ffa4": "Ocurrió un error al preparar el documento para imprimir. Por favor, inténtalo de nuevo.",
  "1fc9a387654d410f": "Seleccionar todo",
  "1ff57a29d7c9d11b": "Siguiente",
  "2db046678b9c9d1d": "Descartar error",
  "331551b0de4157c9": "Pendiente",
  "34fd124089a65f58": "Siguiente documento",
  "3a57bb9fb3bf7756": "¿Estás seguro de que deseas eliminar?",
  "3d67eca0faf5775e": "Algo salió mal al subir. Por favor, inténtalo de nuevo.",
  "3d6a45267218977e": "Esta acción no se puede deshacer.",
  "3f3b4660890bd6d2": "Algo salió mal al eliminar. Por favor, inténtalo de nuevo.",
  "424a2551d356754c": "Caducado",
  "431c4e7642dbf5b6": "Documento eliminado con éxito",
  "43bef92ae98c1c0e": "Cerrar documentos",
  "44837fdf5b780b73": "No se requieren documentos",
  "4850b174b713d88c": "Requerido",
  "4c8261cc8ba3e073": "Subiendo para:",
  "507ae671a6e11521": "Subir documento",
  "5265434bb9e0e789": "No se pudieron cargar los documentos. Por favor, inténtalo de nuevo.",
  "59be71333c960fd0": "Opcional",
  "5e4fd81d3a118c16": "No hay documentos opcionales",
  "61e4e1dc2dd666c4": "Utiliza solo archivos de imagen (sin .html o .xhtml)",
  "6812a1612e7756b4": "{{selectedCount}} seleccionado",
  "6be36ca49ee85210": "Faltante",
  "7009e4afe3c497d5": "Vista previa del documento",
  "7b25a882e9bc3515": "Cerrar visor",
  "84c4c3b5a40e515c": "Elige un archivo para subir",
  "865e89de78d94c74": "Subir",
  "942087cc2d41e013": "Reintentar",
  "a57b08a480b822a0": "Anterior",
  "a64c8281778a453a": "Documento anterior",
  "b09c73d9d3f80210": "Elige un archivo",
  "b4e929d8bcfe0418": "Documentos",
  "bc7b631a689b45ca": "Alejar",
  "cacfb7d8705ac666": "Volver a la lista de documentos",
  "cbeec9440db96406": "Ya hay una descarga en progreso. Por favor, espera a que se complete.",
  "cea4d2e010b8fd52": "Borrar selección",
  "d6eafe8235910042": "Descargar",
  "df0fe79898ef413e": "Imprimir",
  "e2d0a54968ead24e": "Eliminar",
  "e660e4b07c7b75c9": "Ocurrió un error al preparar el documento para descargar. Por favor, inténtalo de nuevo.",
  "ea2b3062479788f4": "Rotar hacia la izquierda",
  "fb594c58c73d2bf8": "Rotar hacia la derecha"
}
